import { Component, Input } from '@angular/core';
import { ModalService } from '@purespectrum1/ui/modal';
import { Criteria } from '../../../../../shared/interfaces/quota.interface';
import { QuotaReviewModalComponent } from '../quota-review-modal/quota-review-modal.component';
import { QualificationNamesMapper } from '../domain/header-info-mapper';
import { AuthService } from '../../../../../shared/services/auth/auth.service';

@Component({
  selector: 'ps-ui-survey-difficult-quotas-info',
  templateUrl: './survey-difficult-quotas-info.component.html',
  styleUrls: ['./survey-difficult-quotas-info.component.css'],
})
export class SurveyDifficultQuotasInfoComponent {
  @Input() impossibleQuotas: boolean = false;
  @Input() difficultQuotas: any[] = [];
  public serviceOperator: boolean =
    this._authService.isLoggedInAsServiceBuyer();

  constructor(
    private _modal: ModalService,
    private _authService: AuthService
  ) {}

  public getTopHeader() {
    let top = 2;
    if (this.serviceOperator) {
      top += 50;
    }
    if (this.impossibleQuotas) {
      top += 60;
    }
    return `${top}px`;
  }

  public openDifficultQuotaModal() {
    this._modal.open(QuotaReviewModalComponent, {
      data: {
        title: `${this.difficultQuotas.length} difficult quotas`,
        type: 'difficult-quotas',
        quotas: this.difficultQuotas,
      },
      width: '50%',
    });
  }

  public getCombinationOfqualification(criteria: Criteria[]) {
    return new QualificationNamesMapper(criteria).names();
  }

  getQuotaStatusClass(): string {
    const isImpossible = this.impossibleQuotas;
    const isAidaEnabled =
      this._authService.buyerConfig?.enableAiDeliveryAssistance;
    const operatorSuffix = this.serviceOperator ? '-service' : '';

    if (isImpossible) {
      return isAidaEnabled
        ? `quota-status-impossible-aida${operatorSuffix}`
        : `quota-status-impossible${operatorSuffix}`;
    }

    return `quota-status-difficult${operatorSuffix}`;
  }
}
